import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TimelineItemType, TopicType } from "@teammood/timeline";

@Component({
    selector: 'publication-preview',
    templateUrl: 'publication-preview.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
    ]
})
export class PublicationPreviewComponent {

    protected itemTypeText: string;
    
    @Input() itemType: TopicType | TimelineItemType;
    @Input() publishNow: boolean; 
  
    ngOnInit(): void {
        switch(this.itemType){
            case 'kudosItem': 
                this.itemTypeText = 'timeline-item-creation-dialog.your-kudos';
                break;
            case 'issue': 
                this.itemTypeText = 'timeline-item-creation-dialog.your-issue';
                break;
            case 'question': 
                this.itemTypeText = 'timeline-item-creation-dialog.your-question';
                break;
        }
    }
}